import React from 'react'
import useOrderStyle from './Order.style'
import { Typography } from '@material-ui/core'

const RentalOrderList = ({ order, showSizes }) => {
  const classes = useOrderStyle()
  return (
    <>
      {order?.rentalOrderList?.map((rentalItem, index) => {
        return (
          <div key={rentalItem.product.name + index}>
            <div className={classes.productCard}>
              <div className={classes.imgContainer}>
                <img
                  src={
                    rentalItem.product.images?.length > 0 &&
                    rentalItem.product?.images?.[0]?.cachedPath
                  }
                  alt={rentalItem.product.name}
                  className={classes.imgProduct}
                />
              </div>
              <div className={classes.productName}>
                <Typography variant={'h5'}>
                  {rentalItem.product.name}
                  {showSizes && rentalItem.product.variants !== 'undefined' && (
                    <>
                      {rentalItem?.product?.variants[0]?.size && (
                        <>&nbsp;-&nbsp;</>
                      )}
                      <Typography variant={'body1'} component="span">
                        {rentalItem?.product?.variants[0]?.size}
                      </Typography>
                    </>
                  )}
                </Typography>
              </div>
            </div>
          </div>
        )
      })}
    </>
  )
}

export default RentalOrderList
